module.exports = __webpack_public_path__ + "assets/img/146505.aea09a79.png";